export default __webpack_public_path__ + "static/media/img_2.a12b36aa.png";